import React from "react";
import Marquee from "react-fast-marquee";
import {
  FaPython,
  FaJava,
  FaJs,
  FaReact,
  FaHtml5,
  FaCss3Alt,
  FaNodeJs,
  FaAws,
  FaGitAlt,
} from "react-icons/fa";
import {
  SiCplusplus,
  SiTypescript,
  SiMongodb,
  SiFastapi,
  SiPandas,
  SiNumpy,
} from "react-icons/si";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";

const LanguageMarquee = () => {
  const iconClass = "mx-6 text-6xl";

  return (
    <div className="p-4 flex flex-col items-center">
      <h1 className="text-xl font-bold mb-4">Languages & Technologies</h1>

      <div className="w-4/5 md:w-1/2 lg:w-2/5 border border-gray-300 rounded-lg overflow-hidden">
        <Marquee speed={55} gradient={false}>
          <SiCplusplus
            data-tooltip-id="lang-tip"
            data-tooltip-content="C++"
            className={`${iconClass} text-blue-600`}
          />

          <FaPython
            data-tooltip-id="lang-tip"
            data-tooltip-content="Python"
            className={`${iconClass} text-yellow-400`}
          />

          <FaJava
            data-tooltip-id="lang-tip"
            data-tooltip-content="Java"
            className={`${iconClass} text-red-600`}
          />

          <FaJs
            data-tooltip-id="lang-tip"
            data-tooltip-content="JavaScript"
            className={`${iconClass} text-yellow-300`}
          />

          <SiTypescript
            data-tooltip-id="lang-tip"
            data-tooltip-content="TypeScript"
            className={`${iconClass} text-blue-500`}
          />

          <FaReact
            data-tooltip-id="lang-tip"
            data-tooltip-content="React"
            className={`${iconClass} text-cyan-400`}
          />

          <FaNodeJs
            data-tooltip-id="lang-tip"
            data-tooltip-content="Node.js"
            className={`${iconClass} text-green-500`}
          />

          <SiFastapi
            data-tooltip-id="lang-tip"
            data-tooltip-content="FastAPI"
            className={`${iconClass} text-teal-500`}
          />

          <FaAws
            data-tooltip-id="lang-tip"
            data-tooltip-content="AWS"
            className={`${iconClass} text-orange-500`}
          />

          <FaGitAlt
            data-tooltip-id="lang-tip"
            data-tooltip-content="Git"
            className={`${iconClass} text-orange-600`}
          />

          <SiMongodb
            data-tooltip-id="lang-tip"
            data-tooltip-content="MongoDB"
            className={`${iconClass} text-green-600`}
          />

          <SiPandas
            data-tooltip-id="lang-tip"
            data-tooltip-content="Pandas"
            className={`${iconClass} text-blue-600`}
          />

          <SiNumpy
            data-tooltip-id="lang-tip"
            data-tooltip-content="NumPy"
            className={`${iconClass} text-blue-500`}
          />

          <FaHtml5
            data-tooltip-id="lang-tip"
            data-tooltip-content="HTML5"
            className={`${iconClass} text-orange-500`}
          />

          <FaCss3Alt
            data-tooltip-id="lang-tip"
            data-tooltip-content="CSS3"
            className={`${iconClass} text-blue-500`}
          />

          {/* Text-only technologies */}
          <span
            data-tooltip-id="lang-tip"
            data-tooltip-content="SQL"
            className="mx-6 text-4xl font-bold text-gray-700"
          >
            SQL
          </span>

          <span
            data-tooltip-id="lang-tip"
            data-tooltip-content="Embedded C"
            className="mx-6 text-4xl font-bold text-gray-700"
          >
            C
          </span>
        </Marquee>
      </div>

      <ReactTooltip
        id="lang-tip"
        place="bottom"
        className="!bg-gray-800 !text-white !px-3 !py-1 !rounded-md text-sm"
      />
    </div>
  );
};

export default LanguageMarquee;
